import React from "react";
import StructuredDataFAQ from '@/components/seo/StructuredDataFAQ';
import BlogFAQSection from '@/components/blog/BlogFAQSection';
import { outdoorCoachingFAQData } from '@/data/faq/outdoor-coaching-faq';

const FAQSection: React.FC = () => {
  const faqData = outdoorCoachingFAQData;

  return (
    <section id="faq" className="section-spacing bg-white">
      <StructuredDataFAQ faqItems={faqData} pageName="Outdoor-Coaching" />
      <div className="container">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="inline-block text-primary font-medium mb-4 px-3 py-1 bg-primary/10 rounded-full text-sm animate-fade-in">
            Häufige Fragen
          </span>
          <h2 className="animate-fade-in" style={{ animationDelay: '100ms' }}>
            Deine Fragen zum Outdoor-Coaching
          </h2>
        </div>

        <BlogFAQSection 
          items={faqData} 
          title="" 
        />
      </div>
    </section>
  );
};

export default FAQSection;